import React from 'react'
import styled from 'styled-components'
import {callIfFunction, getColor} from '@startlibs/utils'
import {Button, Dialog} from '@startlibs/components'
import _ from 'lodash/fp'
import {FormattedMessage} from "react-intl";


const ErrorPageLayout = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: rgba(0,0,0,0.5);
  padding: 1rem;
  @supports (flex-wrap: wrap) {
    display: flex;
    align-items: center;
  }
  a {
    color: ${getColor('main')};
    font-weight: 600;
  }
`
const ErrorCard = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  max-width: 40rem;
  margin: 0 auto;
  p {
    font-size: 14px;
  }
`
const CardHeader = styled.div`
  margin-bottom: 1.5rem;
  h1 {
    color: ${getColor('main')};
    margin-bottom: 0.5rem;
    font-size: 22px;
  }
  p {
    color: rgba(0,0,0,0.5);
    font-size: 14px;
  }
`

export class ProviderErrorBoundary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error) {
    const errorData = error && callIfFunction(error.get)
    const status = _.get([1,'status'],errorData)
    if (errorData && errorData.ignoreError) {
      return {withoutUX:true}
    }
    // Update state so the next render will show the fallback UI.
    return {hasError: true, expired: status  === 410}
  }

  closeDialog = () => {
    this.setState({closingDialog: true})
    setTimeout(() => window.parent.postMessage(JSON.stringify({type: 'removeIframe'}), '*'), 300)
  }

  render() {
    if (this.state.withoutUX) {
      return null
    }
    if (this.state.hasError) {
      if (this.state.expired) {
        return <ErrorPageLayout withoutLogo>
          <ErrorCard>
            <CardHeader>
              <h1><FormattedMessage
                defaultMessage="This link has expired."
                description="Provider link error title"
              /></h1>
            </CardHeader>
            <p><FormattedMessage
              defaultMessage={`Please contact the provider who shared the link with you and ask them to
              reshare your study or reach out to Purview Support for assistance 
              at <mailto>support@purview.net</mailto>`}
              description="Provider link error message"
              values={{
                mailto: chunks => <a className="link" href={`mailto:${chunks[0]}`} target="_blank" rel="noreferrer">{chunks}</a>
              }}
            /></p>
          </ErrorCard>
        </ErrorPageLayout>
      } 
      return <ErrorPageLayout withoutLogo>
        <ErrorCard>
          <CardHeader>
            <h1><FormattedMessage
              defaultMessage="Something went wrong"
              description="Provider error title"
            /></h1>
          </CardHeader>
          <p><b><FormattedMessage
            defaultMessage="Please reload the page and try again."
            description="Provider error message"
          /></b></p>
          <p><FormattedMessage
            defaultMessage={`If the error persists please contact <mailto>support@purview.net</mailto> or <nowrap>call <b>+1 800-501-1537</b>.</nowrap>`}
            description="Provider error support message"
            values={{
              nowrap: chunks => <span className="nowrap">{chunks}</span>,
              b: chunks => <b>{chunks}</b>,
              mailto: chunks => <a className="link" href={`mailto:${chunks[0]}`} target="_blank" rel="noreferrer">{chunks}</a>
            }}
          /></p>
        </ErrorCard>
      </ErrorPageLayout>
    }

    return this.props.children
  }
}

export class DialogErrorBoundary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }

  closeDialog = () => {
    this.setState({closingDialog: true})
    setTimeout(() => window.parent.postMessage(JSON.stringify({type: 'removeIframe'}), '*'), 300)
  }

  render() {
    if (this.state.hasError) {
      return <Dialog
        closeDialog={this.props.closeDialog}
        footer={<Button onClick={this.props.closeDialog}>Close</Button>}
      >
        <ErrorPageLayout withoutLogo>
          <ErrorCard>
            <CardHeader>
              <h1><FormattedMessage
                defaultMessage="Something went wrong"
                description="Provider error title"
              /></h1>
            </CardHeader>
            <p><b><FormattedMessage
              defaultMessage="Please reload the page and try again."
              description="Provider error message"
            /></b></p>
            <p><FormattedMessage
              defaultMessage={`If the error persists please contact <mailto>support@purview.net</mailto> or <nowrap>call <b>+1 800-501-1537</b>.</nowrap>`}
              description="Provider error support message"
              values={{
                nowrap: chunks => <span className="nowrap">{chunks}</span>,
                b: chunks => <b>{chunks}</b>,
                mailto: chunks => <a className="link" href={`mailto:${chunks[0]}`} target="_blank" rel="noreferrer">{chunks}</a>
              }}
            /></p>
          </ErrorCard>
        </ErrorPageLayout>
      </Dialog>
    }

    return this.props.children
  }
}